/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Voucher_Go_PricingInputs */

const en_voucher_go_pricing = /** @type {(inputs: Voucher_Go_PricingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Continue to pricing`)
};

const id_voucher_go_pricing = /** @type {(inputs: Voucher_Go_PricingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lanjut ke halaman harga`)
};

/**
* | output |
* | --- |
* | "Continue to pricing" |
*
* @param {Voucher_Go_PricingInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const voucher_go_pricing = /** @type {((inputs?: Voucher_Go_PricingInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Voucher_Go_PricingInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_voucher_go_pricing(inputs)
	return en_voucher_go_pricing(inputs)
});